module.exports = __webpack_public_path__ + "media/images/down_arrow-30cac363cced4514273e6765763330ae.png";